import { addSentryClientExtra, reportSentryClientError } from "./sentry";

type MailchimpSubscriptionData = {
  email: string;
  tags?: string[];
  mergeFields?: {
    ZIPCODE?: string; // Accept only US zipcodes
    POSTALCODE?: string; // Accept any string value.
    REF_CODE?: string;
    // Custom fields need to be created manually: https://us20.admin.mailchimp.com/lists/settings/merge-tags?id=32115
  };
};

export async function subscribeToMailchimp(data: MailchimpSubscriptionData) {
  const host = process.env.GATSBY_NETLIFY_FUNCTIONS_BASE_URL || "";
  const response = await fetch(
    `${host}/.netlify/functions/mailchimp-subscribe`,
    {
      method: "post",
      body: JSON.stringify({
        email: data.email,
        tags: data.tags || undefined,
        mergeFields: data.mergeFields || undefined
      })
    }
  );

  if (response.ok) {
    return true;
  } else {
    const e = new Error("Something went wrong trying to subscribe your email");
    addSentryClientExtra("netlifyResponseCode", response.statusText);
    reportSentryClientError(e);
    throw e;
  }
}
